import './secondaryLoginButton.scss';

export const SecondaryLoginButton = angular
    .module('checkout.components.secondaryLoginButton', [])
    .component('secondaryLoginButton', {
        template: `
            <hr>
            <div layout layout-align="end center">
                <login-button
                    on-login-clicked="$ctrl.onLoginClicked()">
                </login-button>
            </div>
        `,
        bindings: {
            onLoginClicked: '&'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/secondaryLoginButton/secondaryLoginButton.js